
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the time being, ECL v2 components are composed of vanilla (simple) HTML; adaptable to any technologies while the Twig versions (to be implemented with Drupal 8) will be built within the next 3 months in preparation for the Drupal 8 upgrade.`}</p>
    <p>{`Users can still go to ECL v1 to create or upgrade their websites. In 2019, we will be able to offer users a full set of components from ECL v2 when Drupal 8 is ready.`}</p>
    <p>{`We will also add new components to the ECL v2 as we continue improving the look and feel of the existing components. New releases under v2 should be published periodically under `}<a parentName="p" {...{
        "href": "https://github.com/ec-europa/europa-component-library/releases"
      }}>{`Github`}</a>{`.`}</p>
    <h2>{`2.14.0 (2019-10-25)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1365"
        }}>{`#1365`}</a>{` feat(page-header-core): add component - INNO-1896`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1358"
        }}>{`#1358`}</a>{` feat(page-header-harmonised): add component - INNO-1816`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1373"
        }}>{`#1373`}</a>{` fix(expandable): use aria-expanded attribute - INNO-1899`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1372"
        }}>{`#1372`}</a>{` fix(text-input): remove border radius on iOS - INNO-1904`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1364"
        }}>{`#1364`}</a>{` feat(eu-page-headers): add missing EU variants - INNO-1844`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1362"
        }}>{`#1362`}</a>{` feat(site-header): render class name as a link - INNO-1894`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1378"
        }}>{`#1378`}</a>{` docs: update breadcrumb - INNO-1901`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1377"
        }}>{`#1377`}</a>{` docs: add harmonised g2 page header - INNO-1907`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1374"
        }}>{`#1374`}</a>{` docs: remove bold - INNO-1898`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1363"
        }}>{`#1363`}</a>{` docs(harmonised): update content - INNO-1888`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1361"
        }}>{`#1361`}</a>{` docs(harmonised-1): add page header - INNO-1888`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1367"
        }}>{`#1367`}</a>{` chore: update dependencies - INNO-1811`}</li>
    </ul>
    <h2>{`2.13.0 (2019-10-18)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1341"
        }}>{`#1341`}</a>{` feat(page-header-standardised): add component - INNO-1812`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1340"
        }}>{`#1340`}</a>{` feat(breadcrumb-harmonised): add component - INNO-1817`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1339"
        }}>{`#1339`}</a>{` feat(breadcrumb-standardised): add component - INNO-1809`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1338"
        }}>{`#1338`}</a>{` feat(breadcrumb-core): add component - INNO-1808`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1343"
        }}>{`#1343`}</a>{` fix(site-header): use correct height - INNO-1870`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1355"
        }}>{`#1355`}</a>{` fix(button): simplify markup - INNO-1890`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1349"
        }}>{`#1349`}</a>{` feat(campaign): use harmonised group 2 - INNO-1863`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1348"
        }}>{`#1348`}</a>{` feat(search-page): change template in storybook - INNO-1861`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1354"
        }}>{`#1354`}</a>{` docs(website): update content - INNO-1888`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1353"
        }}>{`#1353`}</a>{` docs(website): update content - INNO-1883`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1345"
        }}>{`#1345`}</a>{` docs(website): add harmonsied site headers and footers - INNO-1871`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1342"
        }}>{`#1342`}</a>{` docs(website): fix typos - INNO-1859`}</li>
    </ul>
    <h2>{`2.12.0 (2019-10-10)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1333"
        }}>{`#1333`}</a>{` feat(site-headers): add menu - INNO-1851`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1328"
        }}>{`#1328`}</a>{` feat(site-header-harmonised): add component - INNO-1813`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1323"
        }}>{`#1323`}</a>{` feat(site-header-standardised): add component - INNO-1815`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1322"
        }}>{`#1322`}</a>{` feat(site-header-core): add component - INNO-1792`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1325"
        }}>{`#1325`}</a>{` feat(icons): add 3 new icons - INNO-1842`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1318"
        }}>{`#1318`}</a>{` feat(harmonised footer): add component - INNO-1820`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1307"
        }}>{`#1307`}</a>{` feat(footer-core): add component - INNO-1774`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1313"
        }}>{`#1313`}</a>{` feat(footer-standardized): add component - INNO-1770`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1320"
        }}>{`#1320`}</a>{` fix(links): change link with icon display - INNO-1829`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1315"
        }}>{`#1315`}</a>{` fix(a11y): fix some accessibility issues - INNO-1831`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1311"
        }}>{`#1311`}</a>{` fix(menu-legacy): add z-index on overlay - INNO-1827`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1301"
        }}>{`#1301`}</a>{` fix(print): add missing utilities - INNO-1773`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1298"
        }}>{`#1298`}</a>{` fix(tag): fix markup for removable tags - INNO-1753`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1293"
        }}>{`#1293`}</a>{` fix(timeline2): fix alignment - INNO-1763`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1334"
        }}>{`#1334`}</a>{` fix(footers): add link - INNO-1855`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1329"
        }}>{`#1329`}</a>{` fix(footer-core): add link - INNO-1848`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1316"
        }}>{`#1316`}</a>{` fix(footer-standardised): small fixes - INNO-1833`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1304"
        }}>{`#1304`}</a>{` refactor(table): apply latest specs - INNO-1793`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1310"
        }}>{`#1310`}</a>{` fix(breadcrumb): use ellipsis on long segments - INNO-1826`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1309"
        }}>{`#1309`}</a>{` feat(icons): update facebook icon - INNO-1825`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1295"
        }}>{`#1295`}</a>{` feat(media): improve media utilities - INNO-1765`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1294"
        }}>{`#1294`}</a>{` fix(content-item): fix image css - INNO-1761`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1335"
        }}>{`#1335`}</a>{` docs: update website content - INNO-1854`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1332"
        }}>{`#1332`}</a>{` docs: update website, add footers - INNO-1852`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1331"
        }}>{`#1331`}</a>{` docs: document harmonised group 1 - INNO-1850`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1330"
        }}>{`#1330`}</a>{` docs(breadcrumbs): update do's - INNO-1849`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1326"
        }}>{`#1326`}</a>{` docs: document core template - INNO-1841`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1306"
        }}>{`#1306`}</a>{` docs: add EU vision page - INNO-1775`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1305"
        }}>{`#1305`}</a>{` docs: fix typo - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1299"
        }}>{`#1299`}</a>{` docs(link): fix typo - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1296"
        }}>{`#1296`}</a>{` docs(eu-about): eu-values and design principle - INNO-1766 - INNO-1767`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1327"
        }}>{`#1327`}</a>{` chore(website): implement new site structure - INNO-1828`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1317"
        }}>{`#1317`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1302"
        }}>{`#1302`}</a>{` chore: update dependencies - INNO-1811`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1292"
        }}>{`#1292`}</a>{` chore(release 2.11): finalize release dev - INNO-1764`}</li>
    </ul>
    <h2>{`2.11.0 (2019-08-30)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1256"
        }}>{`#1256`}</a>{` feat(event-speaker): add template - INNO-1721`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1248"
        }}>{`#1248`}</a>{` feat(events): add event details template - INNO-1719`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1266"
        }}>{`#1266`}</a>{` feat(events): add event agenda template - INNO-1722`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1284"
        }}>{`#1284`}</a>{` feat(utilities): add media utilities - INNO-1755`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1275"
        }}>{`#1275`}</a>{` feat(description-list): add horizontal variant - INNO-1745`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1267"
        }}>{`#1267`}</a>{` feat(site-header): bridge language selector and overlay - INNO-1655`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1265"
        }}>{`#1265`}</a>{` feat(login): provide composition for login bar - INNO-1699`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1262"
        }}>{`#1262`}</a>{` feat(dropdown-legacy): port dropdown from ECL v1 (legacy) - INNO-1725`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1289"
        }}>{`#1289`}</a>{` fix(timeline): set max-width and update font-size - INNO-1762`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1268"
        }}>{`#1268`}</a>{` fix(styles): make styles more resilient - INNO-1737`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1261"
        }}>{`#1261`}</a>{` fix(search-template): fix a11y issue - INNO-1728`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1277"
        }}>{`#1277`}</a>{` refactor(ec-footer): combine EC links - INNO-1748`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1274"
        }}>{`#1274`}</a>{` refactor(eu-footer): update EU footer V2 - INNO-1741`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1286"
        }}>{`#1286`}</a>{` docs(site-header): make language select optional if site not multilingual - INNO-1759`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1270"
        }}>{`#1270`}</a>{` docs(spacing): update usage - INNO-1724`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1264"
        }}>{`#1264`}</a>{` docs: update getting started and contribution guide - no issue`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1287"
        }}>{`#1287`}</a>{` refactor(links): update links to new homepage - INNO-1758`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1272"
        }}>{`#1272`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1271"
        }}>{`#1271`}</a>{` chore(ci): keep build size in check - INNO-958`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1269"
        }}>{`#1269`}</a>{` chore(media): change media output folder - INNO-1267`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1260"
        }}>{`#1260`}</a>{` chore: update dependencies - INNO-1650`}</li>
    </ul>
    <h2>{`2.10.1 (2019-08-16)`}</h2>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1258"
        }}>{`#1258`}</a>{` fix: fix wrong SCSS imports - INNO-1732`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1257"
        }}>{`#1257`}</a>{` fix(drone): fix website deployment - INNO-1731`}</li>
    </ul>
    <h2>{`2.10.0 (2019-08-13)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/984"
        }}>{`#984`}</a>{` feat(checkbox): apply new specifications - INNO-1307`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1247"
        }}>{`#1247`}</a>{` feat(file-upload): add basic file upload - INNO-1717`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1217"
        }}>{`#1217`}</a>{` feat: export to codepen - INNO-1646`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1231"
        }}>{`#1231`}</a>{` feat(dateblock): add component - INNO-1510`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1227"
        }}>{`#1227`}</a>{` feat: initialize JS components automatically (opt-in) - INNO-1680`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1252"
        }}>{`#1252`}</a>{` fix(cards): use aria-label instead of alt - INNO-1727`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1234"
        }}>{`#1234`}</a>{` fix(search-template): fix spacing - INNO-1703`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1229"
        }}>{`#1229`}</a>{` fix(search-form): make input fluid - INNO-1687`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1226"
        }}>{`#1226`}</a>{` fix(table): use bold for headers - INNO-1666`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1253"
        }}>{`#1253`}</a>{` refactor(cards): change image ratio to 3:2 - INNO-1502`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1235"
        }}>{`#1235`}</a>{` fix(label): use inline display - INNO-1704`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1237"
        }}>{`#1237`}</a>{` feat(text-input): add print - INNO-1706`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1236"
        }}>{`#1236`}</a>{` feat(select): add print css - INNO-1477`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1233"
        }}>{`#1233`}</a>{` feat(form-group): allow group classname - INNO-1702`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1222"
        }}>{`#1222`}</a>{` refactor(radio): update radio group - INNO-1452`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1228"
        }}>{`#1228`}</a>{` refactor(select): update styling of select - INNO-1595`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1183"
        }}>{`#1183`}</a>{` refactor(text-inputs): update styling of text inputs - INNO-1593`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1241"
        }}>{`#1241`}</a>{` docs(typography): add coded examples - INNO-1712`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1075"
        }}>{`#1075`}</a>{` docs: define which browsers we support - INNO-1438`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1245"
        }}>{`#1245`}</a>{` docs(spacing): fix incorrect token - INNO-1716`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1239"
        }}>{`#1239`}</a>{` docs(breadcrumb): remove image - INNO-1711`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1191"
        }}>{`#1191`}</a>{` chore(website): enhance performance - INNO-1617`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1246"
        }}>{`#1246`}</a>{` feat(browserslist): update config and display browsers list - INNO-1718`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1240"
        }}>{`#1240`}</a>{` refactor(storybook): use JS auto init - INNO-1709`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1225"
        }}>{`#1225`}</a>{` chore: create knobs for campaign template - INNO-1645`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1238"
        }}>{`#1238`}</a>{` chore: update dependencies - INNO-1710`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1232"
        }}>{`#1232`}</a>{` chore(token): add tokens for form width - INNO-1692`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1219"
        }}>{`#1219`}</a>{` chore: create EU navigation structure - INNO-1651`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1223"
        }}>{`#1223`}</a>{` chore(website): enhance sidebar behaviour - INNO-1659`}</li>
    </ul>
    <h2>{`2.9.0 (2019-07-18)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1218"
        }}>{`#1218`}</a>{` feat: add skip link component - INNO-1653`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1200"
        }}>{`#1200`}</a>{` feat(table): add table - INNO-1628`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1196"
        }}>{`#1196`}</a>{` fix(inpage-nav): add missing polyfills for IE - INNO-1622`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1190"
        }}>{`#1190`}</a>{` chore: hide back to top - INNO-1611`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1220"
        }}>{`#1220`}</a>{` docs(skip-link): add and hide skip link's documentation - INNO-1653`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1213"
        }}>{`#1213`}</a>{` docs(text-field): update documentation of text field - INNO-1641`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1216"
        }}>{`#1216`}</a>{` docs: add playground tab to many pages - INNO-1644`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1215"
        }}>{`#1215`}</a>{` docs(timelines): update documentation of timeline - INNO-1643`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1207"
        }}>{`#1207`}</a>{` docs(message): update documentation of messages - INNO-1635`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1208"
        }}>{`#1208`}</a>{` docs(pagination): update documentation of pagination - INNO-1636`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1212"
        }}>{`#1212`}</a>{` docs: add documentation about social media share - INNO-1640`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1214"
        }}>{`#1214`}</a>{` docs(text-area): update documentation of text area - INNO-1642`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1210"
        }}>{`#1210`}</a>{` docs: add documentation about search form - INNO-1638`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1211"
        }}>{`#1211`}</a>{` docs: add documentation about social media follow - INNO-1639`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1209"
        }}>{`#1209`}</a>{` docs(radio): update documentation of radio - INNO-1637`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1204"
        }}>{`#1204`}</a>{` docs(file): update file download's documentation - INNO-1632`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1206"
        }}>{`#1206`}</a>{` docs(language-list): update documentation of language list - INNO-1634`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1189"
        }}>{`#1189`}</a>{` docs(grid): document grid and provide examples - INNO-1616`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1205"
        }}>{`#1205`}</a>{` docs(inpage-nav): update inpage-nav's documentation - INNO-1633`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1203"
        }}>{`#1203`}</a>{` docs(expandable): update expandable's documentation - INNO-1631`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1201"
        }}>{`#1201`}</a>{` docs(select): update select's documentation - INNO-1630`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1199"
        }}>{`#1199`}</a>{` docs(accordion): update accordion's doc - INNO-1629`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1198"
        }}>{`#1198`}</a>{` docs: add a note about using external SVG sprite - INNO-1625`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1193"
        }}>{`#1193`}</a>{` docs(accordion): update thumbnail - INNO-1610`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1202"
        }}>{`#1202`}</a>{` chore: update dependencies - INNO-1650`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1197"
        }}>{`#1197`}</a>{` refactor(list): split component - INNO-1564`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1195"
        }}>{`#1195`}</a>{` refactor(timeline): split component - INNO-1563`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1194"
        }}>{`#1194`}</a>{` refactor(accordion): split component - INNO-1562`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1192"
        }}>{`#1192`}</a>{` refactor(preset): move deprecated into legacy - INNO-1605`}</li>
    </ul>
    <h2>{`2.8.0 (2019-07-05)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/946"
        }}>{`#946`}</a>{` feat: add menu component - INNO-1603`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1176"
        }}>{`#1176`}</a>{` feat(links): add CTA variant - INNO-1580`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1186"
        }}>{`#1186`}</a>{` fix(inpage-nav): fix styles - INNO-1609`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1185"
        }}>{`#1185`}</a>{` fix(preset-dev): add missing dependencies - INNO-1608`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1182"
        }}>{`#1182`}</a>{` fix(language-list): fix close button color - INNO-1591`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1172"
        }}>{`#1172`}</a>{` feat(gallery): add video management - INNO-1552`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1181"
        }}>{`#1181`}</a>{` refactor(utilities): use !important - INNO-1044`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1175"
        }}>{`#1175`}</a>{` refactor(file): allow different download links - INNO-1582`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1179"
        }}>{`#1179`}</a>{` docs(text-field): provide usage guidelines - INNO-1587`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1177"
        }}>{`#1177`}</a>{` docs(select): provide usage guidelines - INNO-1586`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1174"
        }}>{`#1174`}</a>{` docs: add link to GitHub releases`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1178"
        }}>{`#1178`}</a>{` chore: automate the deployment of ECL website - FPFISSUPP-4104`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1184"
        }}>{`#1184`}</a>{` chore: integrate CCK into the website - INNO-1607`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1173"
        }}>{`#1173`}</a>{` chore: update dependencies - INNO-1566`}</li>
    </ul>
    <h2>{`2.7.0 (2019-06-19)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/993"
        }}>{`#993`}</a>{` feat(inpage-navigation): add component - INNO-1208`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1150"
        }}>{`#1150`}</a>{` feat(content-item): add content item template - INNO-1498`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1167"
        }}>{`#1167`}</a>{` refactor(icons): change instagram icon - INNO-1513`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1163"
        }}>{`#1163`}</a>{` fix(banner): replace button by a link - INNO-1535`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1165"
        }}>{`#1165`}</a>{` docs(website): hide EU pages - INNO-1534`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1169"
        }}>{`#1169`}</a>{` docs(inpage-nav): provide usage guidelines - INNO-1208`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1166"
        }}>{`#1166`}</a>{` docs(radio): provide usage guidelines - INNO-1522`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1168"
        }}>{`#1168`}</a>{` docs(timeline): provide usage guidelines - INNO-1549`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1162"
        }}>{`#1162`}</a>{` docs(text-area): provide usage guidelines - INNO-1516`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1153"
        }}>{`#1153`}</a>{` docs(file): add usage guidelines - INNO-1515`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1164"
        }}>{`#1164`}</a>{` chore(website): prepare publication - INNO-1537`}</li>
    </ul>
    <h2>{`2.6.0 (2019-06-14)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1159"
        }}>{`#1159`}</a>{` feat(accordion2): implement new accordion - INNO-1512`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1143"
        }}>{`#1143`}</a>{` feat(color): add colour helpers - INNO-1494`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1160"
        }}>{`#1160`}</a>{` fix(button): fix display on hover - INNO-1529`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1157"
        }}>{`#1157`}</a>{` docs(messages): provide usage guidelines - INNO-1520`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1158"
        }}>{`#1158`}</a>{` docs(pagination): provide usage guidelines - INNO-1521`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1156"
        }}>{`#1156`}</a>{` docs(gallery): provide usage guidelines - INNO-1519`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1155"
        }}>{`#1155`}</a>{` docs(media-container): provide usage guidelines - INNO-1518`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1154"
        }}>{`#1154`}</a>{` docs(language-list): provide usage guidelines - INNO-1517`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1152"
        }}>{`#1152`}</a>{` docs: add expandable's usage page - INNO-1514`}</li>
    </ul>
    <h2>{`2.5.0 (2019-06-06)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1138"
        }}>{`#1138`}</a>{` feat(border): add border utility - INNO-1495`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1134"
        }}>{`#1134`}</a>{` feat(navigation-lists): create navigation lists composition - INNO-1490`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1129"
        }}>{`#1129`}</a>{` feat(stack): add stacks - INNO-1492`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1124"
        }}>{`#1124`}</a>{` feat(timeline): implement timeline v2 - INNO-1451`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1133"
        }}>{`#1133`}</a>{` fix(timeline2): prevent some props from leaking - INNO-1499`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1126"
        }}>{`#1126`}</a>{` fix(list): change spacing - INNO-1488`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1146"
        }}>{`#1146`}</a>{` chore(icons): un-hide spinner - INNO-1505`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1142"
        }}>{`#1142`}</a>{` refactor(icons): deprecate some icons - INNO-1505`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1140"
        }}>{`#1140`}</a>{` refactor(typography): add rem - px conversion - INNO-1501`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1135"
        }}>{`#1135`}</a>{` refactor(button): apply latest specs - INNO-1500`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1145"
        }}>{`#1145`}</a>{` chore: replace thumbnails - INNO-1503`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1127"
        }}>{`#1127`}</a>{` docs(list): update usage guidelines - INNO-1487`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1136"
        }}>{`#1136`}</a>{` docs: update iconography page`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1128"
        }}>{`#1128`}</a>{` docs(website): rename "text input" to "text field" - INNO-1491`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1125"
        }}>{`#1125`}</a>{` docs: update docs with info about the CDN - INNO-1489`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1123"
        }}>{`#1123`}</a>{` chore: rename storybook folder into playground - INNO-1486`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1147"
        }}>{`#1147`}</a>{` chore: hide contextual nav - INNO-1508`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1148"
        }}>{`#1148`}</a>{` chore: hide site switcher - INNO-1509`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1141"
        }}>{`#1141`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1137"
        }}>{`#1137`}</a>{` chore(website): add thumbnails to Components page - INNO-1503`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1131"
        }}>{`#1131`}</a>{` chore(website): create layout section - INNO-1497`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1130"
        }}>{`#1130`}</a>{` chore(website): make sections collapsible - INNO-1493`}</li>
    </ul>
    <h2>{`2.4.0 (2019-05-14)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1113"
        }}>{`#1113`}</a>{` feat(list): add standard list - INNO-1214`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1085"
        }}>{`#1085`}</a>{` fix(buttons): remove appearance - INNO-1280`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1079"
        }}>{`#1079`}</a>{` fix(website): fix "getting started" display - INNO-1439`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1077"
        }}>{`#1077`}</a>{` fix(language-list): fix demo code and logo alt - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1072"
        }}>{`#1072`}</a>{` fix(logo): fix typo in EU SV logo - INNO-1435`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1063"
        }}>{`#1063`}</a>{` fix(gallery): prevent body scroll - INNO-1428`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1111"
        }}>{`#1111`}</a>{` feat(typography): update print - INNO-1476`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1110"
        }}>{`#1110`}</a>{` feat(spacing): add print css - INNO-1475`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1109"
        }}>{`#1109`}</a>{` feat(radio): add print css - INNO-1473`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1102"
        }}>{`#1102`}</a>{` feat(message): add print css - INNO-1467`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1107"
        }}>{`#1107`}</a>{` feat(timeline): add print css - INNO-1472`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1105"
        }}>{`#1105`}</a>{` feat(social-media-follow): add print css - INNO-1469`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1106"
        }}>{`#1106`}</a>{` feat(social-media-share): add print css - INNO-1471`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1104"
        }}>{`#1104`}</a>{` feat(pagination): add print css - INNO-1468`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1103"
        }}>{`#1103`}</a>{` feat(page-banner): add print css - INNO-1467`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1101"
        }}>{`#1101`}</a>{` feat(language-list): add print css - INNO-1465`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1099"
        }}>{`#1099`}</a>{` feat(gallery): add print css - INNO-1463`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1100"
        }}>{`#1100`}</a>{` feat(hero-banner): add print css - INNO-1464`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1098"
        }}>{`#1098`}</a>{` feat(file): add print css - INNO-1462`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1096"
        }}>{`#1096`}</a>{` feat(contextual-navigation): add print css - INNO-1460`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1097"
        }}>{`#1097`}</a>{` feat(expandable): add print css - INNO-1461`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1095"
        }}>{`#1095`}</a>{` feat(blockquote): add print css - INNO-1459`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1068"
        }}>{`#1068`}</a>{` feat(print): add print styles - INNO-1432`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1062"
        }}>{`#1062`}</a>{` feat(radio): add checked parameter - INNO-1430`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1121"
        }}>{`#1121`}</a>{` docs: update page banner usage page`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1115"
        }}>{`#1115`}</a>{` docs(getting-started): rephrase sentence - INNO-1479`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1112"
        }}>{`#1112`}</a>{` feat(website): add content to main sections pages - INNO-1454`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1071"
        }}>{`#1071`}</a>{` docs(print): how to handle print - INNO-1432`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1094"
        }}>{`#1094`}</a>{` docs: update "getting started" - INNO-1449`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1073"
        }}>{`#1073`}</a>{` docs(usage-wo2): add documentation pages from v2 to v2-dev`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1065"
        }}>{`#1065`}</a>{` docs(list): rephrase definition`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1120"
        }}>{`#1120`}</a>{` chore(storybook): organize stories by "title" - INNO-1483`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1119"
        }}>{`#1119`}</a>{` chore(website): add link tabs to playground - INNO-1482`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1118"
        }}>{`#1118`}</a>{` chore(storybook): rename Code into HTML - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1117"
        }}>{`#1117`}</a>{` chore: add shadow to images - INNO-1481`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1116"
        }}>{`#1116`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1114"
        }}>{`#1114`}</a>{` feat(storybook): add "code" addon - INNO-1478`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1108"
        }}>{`#1108`}</a>{` chore: update dependencies - INNO-1474`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1093"
        }}>{`#1093`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1086"
        }}>{`#1086`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1067"
        }}>{`#1067`}</a>{` chore: update dependencies - no issue`}</li>
    </ul>
    <h2>{`2.3.0 (2019-03-28)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1052"
        }}>{`#1052`}</a>{` feat(radio): add component - INNO-1353`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/994"
        }}>{`#994`}</a>{` feat(template-search): add template - INNO-1315`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1053"
        }}>{`#1053`}</a>{` docs(contributing): update guide - noissue`}</li>
    </ul>
    <h2>{`2.2.0 (2019-03-21)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/952"
        }}>{`#952`}</a>{` feat(gallery): apply new specs - INNO-1162`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1042"
        }}>{`#1042`}</a>{` fix(select): use same min/max widths as text input - INNO-1406`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1039"
        }}>{`#1039`}</a>{` fix(accordion): fix accessibility - INNO-1394`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1038"
        }}>{`#1038`}</a>{` fix(templates): make sure "back to top" links to the top - INNO-1395`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1036"
        }}>{`#1036`}</a>{` fix(icons): remove g+ icon - INNO-1393`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1035"
        }}>{`#1035`}</a>{` fix(forms): remove space before hidden label - INNO-1391`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1031"
        }}>{`#1031`}</a>{` fix(tag): fix React component for IE 11 - INNO-1385`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1030"
        }}>{`#1030`}</a>{` fix: improve social-media-`}{`*`}{` on IE 11 - INNO-1386`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1028"
        }}>{`#1028`}</a>{` fix(site-header): fix alignment in IE 11 - INNO-1388`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1027"
        }}>{`#1027`}</a>{` fix(search-form): fix layout issue - INNO-1380`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1026"
        }}>{`#1026`}</a>{` fix(accordion): fix display issue on IE 11 - INNO-1381`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1025"
        }}>{`#1025`}</a>{` fix(file): rotate icon on expand/collapse - INNO-1382`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1022"
        }}>{`#1022`}</a>{` fix: fix contextual-navigation's button - INNO-1377`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1021"
        }}>{`#1021`}</a>{` fix: export classes correctly - INNO-1354`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1034"
        }}>{`#1034`}</a>{` feat(template): add language list - INNO-1389`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1007"
        }}>{`#1007`}</a>{` refactor(language-list): improve markup - INNO-1321`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1006"
        }}>{`#1006`}</a>{` refactor(file): improve markup - INNO-1320`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1019"
        }}>{`#1019`}</a>{` docs(site): add usage guidelines WO1`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1023"
        }}>{`#1023`}</a>{` docs(whats-new): poc`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1032"
        }}>{`#1032`}</a>{` docs: change ECL 1 version - no issue`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1047"
        }}>{`#1047`}</a>{` fix(components): hide components - INNO-1411`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1046"
        }}>{`#1046`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1045"
        }}>{`#1045`}</a>{` refactor(message): rename message - INNO-1405`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1044"
        }}>{`#1044`}</a>{` refactor(expandable): rename expandable - INNO-1404`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1041"
        }}>{`#1041`}</a>{` fix(storybook): add images for local tests - INNO-1397`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1043"
        }}>{`#1043`}</a>{` refactor(banners): group banners - INNO-1402`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1033"
        }}>{`#1033`}</a>{` chore: update dependencies - INNO-1392`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1029"
        }}>{`#1029`}</a>{` fix(status): prevent status shrinking - INNO-1387`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1018"
        }}>{`#1018`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1010"
        }}>{`#1010`}</a>{` refactor(components): homogenization - INNO-1324`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1012"
        }}>{`#1012`}</a>{` feat(website): display version number - INNO-1325`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1005"
        }}>{`#1005`}</a>{` chore: setup v2-dev branch`}</li>
    </ul>
    <h2>{`2.1.1 (2019-02-14)`}</h2>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1013"
        }}>{`#1013`}</a>{` fix(ecl-builder): update dependencies, fix scripts build - no issue`}</li>
    </ul>
    <h2>{`2.1.0 (2019-02-05)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/992"
        }}>{`#992`}</a>{` feat(accordion): add component - INNO-1232`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/973"
        }}>{`#973`}</a>{` feat(expandable): add expandable - INNO-1288`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/985"
        }}>{`#985`}</a>{` feat(button): add disable state - INNO-1293`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/979"
        }}>{`#979`}</a>{` feat(select): apply new specs - INNO-1304`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/959"
        }}>{`#959`}</a>{` feat(file): apply new specs - INNO-1245`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/948"
        }}>{`#948`}</a>{` feat(timeline): apply new specs - INNO-1215`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/983"
        }}>{`#983`}</a>{` feat(back-to-top): apply specs - INNO-1244`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/981"
        }}>{`#981`}</a>{` feat(icons): add instagram icon - INNO-1302`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/950"
        }}>{`#950`}</a>{` feat(social-media-share): add component - INNO-1264`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/976"
        }}>{`#976`}</a>{` feat(website): add footer example - no issue`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1000"
        }}>{`#1000`}</a>{` fix: use outline for form elements - INNO-1318`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/991"
        }}>{`#991`}</a>{` feat(icons): enhance a11y, remove focusable on IE 11 - INNO-1310`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/990"
        }}>{`#990`}</a>{` fix(eu-footer): update layout - INNO-1311`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/978"
        }}>{`#978`}</a>{` feat(website): add table styling - INNO-1294`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/942"
        }}>{`#942`}</a>{` docs(developer): update developers documentation for v2 - INNO-1277`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/1002"
        }}>{`#1002`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/999"
        }}>{`#999`}</a>{` fix(website): add missing polyfills for IE11 - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/997"
        }}>{`#997`}</a>{` chore: improve stale-bot configuration`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/995"
        }}>{`#995`}</a>{` chore: update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/968"
        }}>{`#968`}</a>{` refactor(website): apply specs`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/988"
        }}>{`#988`}</a>{` chore(dependencies): update dependencies - no issue`}</li>
    </ul>
    <h2>{`2.0.0 (2018-12-10)`}</h2>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/970"
        }}>{`#970`}</a>{` docs: update title on EU homepage`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/974"
        }}>{`#974`}</a>{` chore: update dependencies - no issue`}</li>
    </ul>
    <h2>{`2.0.0-beta.0 (2018-11-30)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/954"
        }}>{`#954`}</a>{` feat(contextual-navigation): apply new specs - INNO-1236`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/944"
        }}>{`#944`}</a>{` feat(message): apply new specs - INNO-1276`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/938"
        }}>{`#938`}</a>{` feat(typography): add paragraphs and headings - 1271`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/932"
        }}>{`#932`}</a>{` feat(pager): add component - INNO-1218`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/925"
        }}>{`#925`}</a>{` feat(social-media-follow): add component - INNO-1221`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/963"
        }}>{`#963`}</a>{` fix(react-warnings): fix React warnings - INNO-1292`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/937"
        }}>{`#937`}</a>{` fix(site-header): fix alignment - INNO-1272`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/931"
        }}>{`#931`}</a>{` fix(breadcrumb): remove extra span - INNO-1269`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/961"
        }}>{`#961`}</a>{` refactor(website): update usage tab`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/960"
        }}>{`#960`}</a>{` refactor(website): update showcase display - INNO-1283`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/957"
        }}>{`#957`}</a>{` feat(logo): add logo translations - INNO-1285`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/956"
        }}>{`#956`}</a>{` fix(footer): ECL 2.x add missing links - INNO-1286`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/945"
        }}>{`#945`}</a>{` feat(website-section-pages): bootstrap sections pages - INNO-1274`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/941"
        }}>{`#941`}</a>{` feat(iframes): enhance iframes on website - INNO-1275`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/933"
        }}>{`#933`}</a>{` feat(templates): update existing templates' showcase - INNO-1270`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/958"
        }}>{`#958`}</a>{` docs(grid): adding new content`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/949"
        }}>{`#949`}</a>{` doc(getting-started) --no-issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/939"
        }}>{`#939`}</a>{` docs: fix small typo`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/940"
        }}>{`#940`}</a>{` docs: fix small typo`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/936"
        }}>{`#936`}</a>{` docs: correct text`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/929"
        }}>{`#929`}</a>{` docs(ec/typography): suggest new structure`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/916"
        }}>{`#916`}</a>{` docs(ec/media-container): introduce media container`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/801"
        }}>{`#801`}</a>{` docs(ec/inpage-nav): add usage for inpage navigation`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/921"
        }}>{`#921`}</a>{` docs(ec/guidelines): draft use of images`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/919"
        }}>{`#919`}</a>{` docs(eu/page-banner): introduce EU page banner`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/918"
        }}>{`#918`}</a>{` docs(ec/page-banner): introduce EC page banner`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/920"
        }}>{`#920`}</a>{` docs(eu/hero-banner): introduce hero banner`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/967"
        }}>{`#967`}</a>{` chore(deps): update dependencies and pullapprove v3 - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/964"
        }}>{`#964`}</a>{` chore(v2): prepare branch v2 - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/962"
        }}>{`#962`}</a>{` chore(deps): update dependencies and apply prettier - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/927"
        }}>{`#927`}</a>{` chore(deps): keep dependencies up-to-date - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/934"
        }}>{`#934`}</a>{` chore(react-dependencies): harmonize react packages' dependencies - INNO-1268`}</li>
    </ul>
    <h2>{`2.0.0-alpha.3 (2018-10-23)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/894"
        }}>{`#894`}</a>{` feat(page-banner): add component - INNO-1230`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/901"
        }}>{`#901`}</a>{` feat(campaign): bootstrap ec campaign template`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/898"
        }}>{`#898`}</a>{` feat(spacing): add spacing utilities - INNO-1259`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/888"
        }}>{`#888`}</a>{` feat(eu/templates): add campaign template - INNO-1258`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/876"
        }}>{`#876`}</a>{` feat(typography): add paragraph - INNO-1252`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/884"
        }}>{`#884`}</a>{` fix(image): add example image - INNO-1257`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/923"
        }}>{`#923`}</a>{` feat(template): add link to webtools widget - INNO-1221`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/908"
        }}>{`#908`}</a>{` fix(hero-banner): add semantic - INNO-1262`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/889"
        }}>{`#889`}</a>{` feat(website/nav): refactor navigation to support groups - INNO-1255`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/907"
        }}>{`#907`}</a>{` feat(campaign): add extra demo data for cards, adjust layout.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/897"
        }}>{`#897`}</a>{` feat(search-form): add label - no issue`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/915"
        }}>{`#915`}</a>{` docs(ec/links): add introduction`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/914"
        }}>{`#914`}</a>{` docs(ec/tags): add introduction`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/913"
        }}>{`#913`}</a>{` docs(ec/site-switcher): add introduction`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/911"
        }}>{`#911`}</a>{` docs(eu/campaign): introduce campaign`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/912"
        }}>{`#912`}</a>{` docs(ec/campaign): introduce campaign template`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/910"
        }}>{`#910`}</a>{` docs(ec/cards): provide content`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/903"
        }}>{`#903`}</a>{` docs(eu/what's new): draft first version of What's new`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/904"
        }}>{`#904`}</a>{` docs(ec/what's-new): draft first version of What's new`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/902"
        }}>{`#902`}</a>{` docs(ec/getting-started): update Getting started`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/905"
        }}>{`#905`}</a>{` docs(eu/getting-started): draft first version of Getting started`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/906"
        }}>{`#906`}</a>{` docs(ec/site-header): add image for site header`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/900"
        }}>{`#900`}</a>{` docs(ec/template): update the content that is more suitable`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/891"
        }}>{`#891`}</a>{` docs: add typography pages`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/895"
        }}>{`#895`}</a>{` docs(ec/template-standard): update usage.md`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/896"
        }}>{`#896`}</a>{` docs(eu/template-standard): update EU Standard template intro`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/893"
        }}>{`#893`}</a>{` docs(ec/standard-template): add EC Standard template intro`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/887"
        }}>{`#887`}</a>{` docs(versions): add links to previous versions`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/924"
        }}>{`#924`}</a>{` feat(template-showcase): enhance showcase of templates - INNO-1265`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/926"
        }}>{`#926`}</a>{` chore(preset-dev): add "dev" preset - INNO-1266`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/909"
        }}>{`#909`}</a>{` chore(website): rearrange categories - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/899"
        }}>{`#899`}</a>{` chore(logo): remove standalone logo - INNO-1260`}</li>
    </ul>
    <h2>{`2.0.0-alpha.2 (2018-10-15)`}</h2>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/881"
        }}>{`#881`}</a>{` fix(ec-template): use corporate footer`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/883"
        }}>{`#883`}</a>{` feat(template): add site switcher - INNO-1256`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/878"
        }}>{`#878`}</a>{` fix(card): update card structure - INNO-1254`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/880"
        }}>{`#880`}</a>{` docs(ec/footer): add intro`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/882"
        }}>{`#882`}</a>{` chore(alpha2): prepare alpha.2 release`}</li>
    </ul>
    <h2>{`2.0.0-alpha.1 (2018-10-11)`}</h2>
    <p>{`Re-publish packages.`}</p>
    <h2>{`2.0.0-alpha.0 (2018-10-11)`}</h2>
    <h4>{`🚀 New Feature`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/861"
        }}>{`#861`}</a>{` feat(standard-page): add page templates - INNO-1251`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/862"
        }}>{`#862`}</a>{` feat(eu/media-container): implement EU media container - INNO-1153`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/823"
        }}>{`#823`}</a>{` feat(media-container): bootstrap component - INNO-1153`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/854"
        }}>{`#854`}</a>{` feat(ec-footer): apply new specs - INNO-1157`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/840"
        }}>{`#840`}</a>{` feat(footer): apply new specs - INNO-1182`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/844"
        }}>{`#844`}</a>{` feat(eu-page-header): implement new specs - INNO-1184`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/828"
        }}>{`#828`}</a>{` feat(page-header-ec): implement EC page header - INNO-1210`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/829"
        }}>{`#829`}</a>{` feat(cards): apply new specifications`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/827"
        }}>{`#827`}</a>{` feat(language-list-ec): implement EC language list - INNO-1180`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/813"
        }}>{`#813`}</a>{` feat(breadcrumb): apply new specs - INNO-1198`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/817"
        }}>{`#817`}</a>{` feat(language-list): apply new specs - INNO-1186`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/815"
        }}>{`#815`}</a>{` feat(site-switcher): implement site switcher - INNO-1219`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/804"
        }}>{`#804`}</a>{` feat(tag): implement new specs for tag - INNO-1201`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/812"
        }}>{`#812`}</a>{` feat(link): allow usage of icon - INNO-1176`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/811"
        }}>{`#811`}</a>{` feat(eu-header): apply new specs - INNO-1203`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/798"
        }}>{`#798`}</a>{` feat(date-block): implement date block component - INNO-1204`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/805"
        }}>{`#805`}</a>{` feat(search-form): Apply new specs - INNO-1151`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/807"
        }}>{`#807`}</a>{` feat(logo): add eu logo - INNO-1217`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/800"
        }}>{`#800`}</a>{` feat(hero-banner): add component - INNO-1181`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/797"
        }}>{`#797`}</a>{` feat(button): add icons - INNO-1167`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/788"
        }}>{`#788`}</a>{` refactor(icons): update all icons - INNO-1191`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/782"
        }}>{`#782`}</a>{` feat(text-input): add react component - INNO-1192`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/778"
        }}>{`#778`}</a>{` refactor(logo): add react component - INNO-1177`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/777"
        }}>{`#777`}</a>{` feat(clipboard): copy to clipboard PoC - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/776"
        }}>{`#776`}</a>{` feat(website-tokens): display tokens as lists (colors, breakpoint) - INNO-1170`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/753"
        }}>{`#753`}</a>{` feat(website-nav): update main nav - INNO-1125`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/728"
        }}>{`#728`}</a>{` feat(website): bootstrap new website based on React - INNO-1128`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/723"
        }}>{`#723`}</a>{` feat(design-tokens): init design tokens' integration - INNO-914`}</li>
    </ul>
    <h4>{`💥 Breaking Change`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/768"
        }}>{`#768`}</a>{` feat(grid): implement new grid - INNO-1132`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/773"
        }}>{`#773`}</a>{` chore(twig): extract twig templates from vanilla implementations - INNO-1166`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/726"
        }}>{`#726`}</a>{` refactor(icons): revamp icons for ECL 2.x`}</li>
    </ul>
    <h4>{`🐛 Bug Fix`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/868"
        }}>{`#868`}</a>{` fix(content): replace "color" by "colour" - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/860"
        }}>{`#860`}</a>{` fix(website): add status, missing pages - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/843"
        }}>{`#843`}</a>{` fix(cards): remove min-width and fix react components - INNO-1187`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/839"
        }}>{`#839`}</a>{` fix(links): remove visited styles - INNO-1247`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/833"
        }}>{`#833`}</a>{` fix(storybook): fix storybook on IE11 - INNO-1243`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/832"
        }}>{`#832`}</a>{` fix(site-switcher): follow design specs - INNO-1242`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/796"
        }}>{`#796`}</a>{` fix(text-fields): remove spacing and icon - INNO-1192`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/790"
        }}>{`#790`}</a>{` fix(tokens): fix spacing sm - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/789"
        }}>{`#789`}</a>{` fix(link): remove font specificity - INNO-1179`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/786"
        }}>{`#786`}</a>{` fix(logo): remove mute logo - INNO-1185`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/779"
        }}>{`#779`}</a>{` chore(twig-cleanup): remove fractal custom theme - INNO-1183`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/760"
        }}>{`#760`}</a>{` fix(props-types): fix PropTypes declaration - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/756"
        }}>{`#756`}</a>{` fix(router): append / to urls - INNO-1164`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/754"
        }}>{`#754`}</a>{` fix(website): remove a11y tabs - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/751"
        }}>{`#751`}</a>{` fix(website-grid): fix grid on IE 10+ - INNO-1149`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/743"
        }}>{`#743`}</a>{` fix(button): add flex container - INNO-1137`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/737"
        }}>{`#737`}</a>{` fix(tags): multiline tags - INNO-1140`}</li>
    </ul>
    <h4>{`💅 Enhancement`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/866"
        }}>{`#866`}</a>{` fix(breadcumb): wrap long segment.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/850"
        }}>{`#850`}</a>{` feat(website-nav): restructure side nav - INNO-1248`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/838"
        }}>{`#838`}</a>{` feat(colors): update colors - INNO-1246`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/830"
        }}>{`#830`}</a>{` feat(colors): add missing grey 20 - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/825"
        }}>{`#825`}</a>{` feat(hero): update EC/EU hero banner - INNO-1233`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/824"
        }}>{`#824`}</a>{` feat(site-header): port EU version to EC - INNO-1237`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/818"
        }}>{`#818`}</a>{` refactor(website): use 12-columns grid - INNO-1231`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/810"
        }}>{`#810`}</a>{` feat(icon-tokens): tokenize icons by category - INNO1188`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/784"
        }}>{`#784`}</a>{` feat(website): update splash page - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/793"
        }}>{`#793`}</a>{` chore(babel): upgrade to babel 7 - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/791"
        }}>{`#791`}</a>{` feat(text-fields): add label + helper + validation message - INNO-1192`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/781"
        }}>{`#781`}</a>{` chore(website): switch CSS depending on the system - INNO-1173`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/780"
        }}>{`#780`}</a>{` chore(website): add status to components - INNO-1171`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/767"
        }}>{`#767`}</a>{` chore(theme): clean up color mapping -NO-ISSUE`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/765"
        }}>{`#765`}</a>{` refactor(button): apply new specs - INNO-1161`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/770"
        }}>{`#770`}</a>{` feat(content): update usage blockquote - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/758"
        }}>{`#758`}</a>{` feat(colors): add more colours - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/764"
        }}>{`#764`}</a>{` feat(content): update website content - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/762"
        }}>{`#762`}</a>{` feat(storybook): create PoC with storybook - INNO-1165`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/755"
        }}>{`#755`}</a>{` feat(website): use theme - INNO-1159`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/744"
        }}>{`#744`}</a>{` feat(website): implement splash page - INNO-1130`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/735"
        }}>{`#735`}</a>{` feat(website): add more components, pt2 - INNO-1139`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/732"
        }}>{`#732`}</a>{` feat(website): add more components - INNO-1139`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/727"
        }}>{`#727`}</a>{` feat(design-tokens): tokenise spacing and color - INNO-1116`}</li>
    </ul>
    <h4>{`📝 Documentation`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/872"
        }}>{`#872`}</a>{` docs(ec/space): document version01`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/873"
        }}>{`#873`}</a>{` docs(ec/blockquote): update`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/865"
        }}>{`#865`}</a>{` docs(eu/homepage): add official version`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/864"
        }}>{`#864`}</a>{` docs(ec/homepage): add official version`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/863"
        }}>{`#863`}</a>{` docs(splash): add the political correct version`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/859"
        }}>{`#859`}</a>{` docs: update EC page header - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/858"
        }}>{`#858`}</a>{` docs(ec/breadcrumb): edit documentation - no-issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/853"
        }}>{`#853`}</a>{` docs(ec/eui): update eui.md - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/857"
        }}>{`#857`}</a>{` docs(eu/footer): update usage.md - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/849"
        }}>{`#849`}</a>{` docs(hero banner): version01`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/847"
        }}>{`#847`}</a>{` docs: add content for eUI`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/841"
        }}>{`#841`}</a>{` docs: add webtools intro page`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/835"
        }}>{`#835`}</a>{` docs(Breadcrumb-ec): document EC breadcrumb`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/837"
        }}>{`#837`}</a>{` docs(Footer-EC): provide first version`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/836"
        }}>{`#836`}</a>{` docs(Buttons): first version`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/834"
        }}>{`#834`}</a>{` docs: update blockquote docs`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/820"
        }}>{`#820`}</a>{` docs: add application`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/822"
        }}>{`#822`}</a>{` docs: update EU introduction page`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/821"
        }}>{`#821`}</a>{` docs: update introduction`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/806"
        }}>{`#806`}</a>{` docs(colors): improve docs presentation - INNO-1213`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/745"
        }}>{`#745`}</a>{` docs: update "How to update documentation on ECL" - no issue`}</li>
    </ul>
    <h4>{`🏠 Internal`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/869"
        }}>{`#869`}</a>{` chore(cleanup): use new playground for every components - no-issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/842"
        }}>{`#842`}</a>{` chore(deps): keep dependencies up-to-date - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/831"
        }}>{`#831`}</a>{` chore(alpha0): clean up code base before alpha 0 - INNO-1239`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/819"
        }}>{`#819`}</a>{` chore(eslint): lint JSX files - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/816"
        }}>{`#816`}</a>{` chore(dev-server): replace webpack-serve with webpack-dev-server`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/802"
        }}>{`#802`}</a>{` chore(markdown): make homepage as markdown files - INNO-1211`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/795"
        }}>{`#795`}</a>{` feat(design-tokens): rely on design tokens only - INNO-1209`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/792"
        }}>{`#792`}</a>{` chore(twig): remove twig + fractal - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/785"
        }}>{`#785`}</a>{` chore(cleanup): clean up vanilla implementations - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/783"
        }}>{`#783`}</a>{` chore(website): use CSS modules - INNO-1172`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/775"
        }}>{`#775`}</a>{` refactor(link): add react component`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/774"
        }}>{`#774`}</a>{` chore(website): move playground component at upper level - INNO-1175`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/772"
        }}>{`#772`}</a>{` chore(lerna): switch to fixed versioning - INNO-1120`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/769"
        }}>{`#769`}</a>{` chore(deps): update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/746"
        }}>{`#746`}</a>{` feat(showcase): showcase for buttons - INNO-1146`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/750"
        }}>{`#750`}</a>{` feat(themes): separate themes from design tokens - INNO-1148`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/742"
        }}>{`#742`}</a>{` chore(dependencies): update dependencies - no issue`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/739"
        }}>{`#739`}</a>{` refactor(structure): revamp folder architecture - INNO-1143`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ec-europa/europa-component-library/pull/730"
        }}>{`#730`}</a>{` feat(design-token): PoC - INNO-1127`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;